import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const BusinessModelProLayout = lazy(() =>
  import('../components/business-model-pro/BusinessModelProLayout').then((m) => ({ default: m.BusinessModelProLayout }))
)
const BizModHubPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.HubPage }))
)
const BizModCockpitPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.CockpitPage }))
)
const BizModScorePage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.ScorePage }))
)
const BizModMaturitePage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.MaturitePage }))
)
const BizModAiProjectPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.AiProjectPage }))
)
const BizModBusinessModelPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.BusinessModelPage }))
)
const BizModCustomCanvasPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.CustomCanvasPage }))
)
const BizModCanvasLibraryPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.CanvasLibraryPage }))
)
const BizModSessionsPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.SessionsPage }))
)
const BizModSessionDetailPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.SessionDetailPage }))
)
const BizModContributionsPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.ContributionsPage }))
)
const BizModConsolidationPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.ConsolidationPage }))
)
const BizModPlenaryPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.PlenaryPage }))
)
const BizModStrategicAlignmentPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.StrategicAlignmentPage }))
)
const BizModImpactAnalysisPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.ImpactAnalysisPage }))
)
const BizModGuidedQuestionsPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.GuidedQuestionsPage }))
)
const BizModBenchmarkingPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.BenchmarkingPage }))
)
const BizModFrameworksPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.BizModFrameworksPage }))
)
const BizModLeanCanvasPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.LeanCanvasPage }))
)
const BizModValuePropositionPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.ValuePropositionPage }))
)
const BizModCertificationPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.BizModCertificationPage }))
)
const BizModReportExecPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.BizModReportExecPage }))
)
const BizModIntegrationsPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.BizModIntegrationsPage }))
)
const BizModAuditTrailPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.BizModAuditTrailPage }))
)
const BizModSettingsPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.BizModSettingsPage }))
)
const BizModOutilsPage = lazy(() =>
  import('../pages/business-model-pro').then((m) => ({ default: m.BizModOutilsPage }))
)

export const businessModelProRoutes: RouteObject[] = [
  {
    path: '/business-model-pro',
    element: <BusinessModelProLayout />,
    children: [
      { index: true, element: <BizModHubPage /> },

      { path: 'hub', element: <BizModHubPage /> },
      { path: 'cockpit', element: <BizModCockpitPage /> },
      { path: 'score', element: <BizModScorePage /> },
      { path: 'maturite', element: <BizModMaturitePage /> },
      { path: 'ai-project', element: <BizModAiProjectPage /> },
      { path: 'business-model', element: <BizModBusinessModelPage /> },
      { path: 'custom-canvas', element: <BizModCustomCanvasPage /> },
      { path: 'canvas-library', element: <BizModCanvasLibraryPage /> },
      // Profile-MD alias
      { path: 'canvas', element: <BizModCanvasLibraryPage /> },
      { path: 'sessions', element: <BizModSessionsPage /> },
      { path: 'sessions/:id', element: <BizModSessionDetailPage /> },
      { path: 'contributions', element: <BizModContributionsPage /> },
      { path: 'consolidation', element: <BizModConsolidationPage /> },
      { path: 'plenary', element: <BizModPlenaryPage /> },
      { path: 'strategic-alignment', element: <BizModStrategicAlignmentPage /> },
      { path: 'impact-analysis', element: <BizModImpactAnalysisPage /> },
      { path: 'guided-questions', element: <BizModGuidedQuestionsPage /> },
      { path: 'benchmarking', element: <BizModBenchmarkingPage /> },
      { path: 'frameworks', element: <BizModFrameworksPage /> },
      { path: 'lean-canvas', element: <BizModLeanCanvasPage /> },
      { path: 'value-proposition', element: <BizModValuePropositionPage /> },
      { path: 'certification', element: <BizModCertificationPage /> },
      { path: 'reports', element: <BizModReportExecPage /> },
      { path: 'integrations', element: <BizModIntegrationsPage /> },
      { path: 'audit-trail', element: <BizModAuditTrailPage /> },
      { path: 'settings', element: <BizModSettingsPage /> },
      { path: 'outils', element: <BizModOutilsPage /> },
    ],
  },
]
